import { useCallback } from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { getBid, getSecureBid, getBids, getBidDealer } from 'app/store/modules/estimate';
import { numberWithCommas } from 'app/libs/number';

export default function useBids() {
	const { bid, bids, bidDealer } = useSelector((state) => state.estimate, shallowEqual);
	const dispatch = useDispatch();

	const getBidInfo = useCallback((estimateId) => dispatch(getBid(estimateId)), [dispatch]);
	const getSecureBidInfo = useCallback((estimateId) => dispatch(getSecureBid(estimateId)), [dispatch]);
	const getBidsInfo = useCallback((estimateId) => dispatch(getBids(estimateId)), [dispatch]);
	const getBidDealerInfo = useCallback((dealerId, estimateId) => dispatch(getBidDealer(dealerId, estimateId)), [dispatch]);
	const getPriceArray = useCallback(() => bids.map(({ price }) => price), [bids]);
	const getLength = useCallback(() => bids.length, [bids]);
	const getMax = useCallback(() => Math.max(...getPriceArray()), [getPriceArray]);
	const getAvg = useCallback(() => {
		const priceArr = getPriceArray();
		return Math.round(priceArr.reduce((acc, cur) => acc + cur, 0) / getLength());
	}, [getPriceArray, getLength]);
	const getCategory = useCallback(() => getPriceArray().map((price) => `${numberWithCommas(price)} 만원`), [getPriceArray]);
	const getSeries = useCallback(
		() =>
			bids.map((item) => {
				const gradient = {
					linearGradient: {
						x1: 0,
						x2: 0,
						y1: 0,
						y2: 1,
					},
					stops: [
						[0, '#FF0E00'],
						[1, '#FF6500'],
					],
				};
				const { price, isSuccess } = item;
				return {
					y: price,
					color: isSuccess ? gradient : '#f0f0f0',
				};
			}),
		[bids],
	);

	return {
		bid,
		bidDealer,
		bids,
		getBidInfo,
		getBidDealerInfo,
		getSecureBidInfo,
		getBidsInfo,
		getLength,
		getMax,
		getAvg,
		getCategory,
		getSeries,
	};
}
